export default __webpack_public_path__ + "e5d3c8e3db93597f22df1d945073ec5b.gif";